import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';

const ThankYou = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';

  useEffect(() => {
    const timer = setTimeout(() => navigate('/'), 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 flex items-center justify-center">
      <div className="text-center px-6">
        <CheckCircle className="w-24 h-24 text-green-400 mx-auto mb-6" />
        <h1 className="text-4xl font-bold text-white mb-4">Thank You!</h1>
        <p className="text-xl text-white/70 mb-2">
          {isZh ? '感谢您的提交，我们会尽快与您联系。' : 'Thank you for your submission. We will contact you shortly.'}
        </p>
        <p className="text-sm text-white/40">
          {isZh ? '3秒后自动返回首页...' : 'Redirecting to homepage in 3 seconds...'}
        </p>
      </div>
    </div>
  );
};

export default ThankYou;
